(() => {
  const ELEMENT_NAME = 'rebuy-cart-drawer-widget'
  const CART_DRAWER_SELECTOR = '#CartDrawer'
  const PRODUCT_WIDGET_SELECTOR =
    '.custom-app-block--inside-product-section [id^="rebuy-widget-"].rebuy-widget'
  const REBUY_PRICE_SELECTOR = '.rebuy-product-price .rebuy-money'
  const REBUY_ADD_EVENT = 'rebuy.add'

  if (window.customElements.get(ELEMENT_NAME)) {
    return
  }

  const desktopMediaQuery = window.matchMedia('(min-width: 768px)')
  const widgetCache = new Map()
  let priceFormattingQueued = false
  let updateQueued = false

  const getWidgetElement = placement => placement.querySelector(':scope > [data-rebuy-id]')

  const initializeRebuy = () => {
    window.requestAnimationFrame(() => {
      window.Rebuy?.init?.()
    })
  }

  const updateActiveWidget = () => {
    updateQueued = false

    const placements = [...document.querySelectorAll(ELEMENT_NAME)]
    const activeViewport = desktopMediaQuery.matches ? 'desktop' : 'mobile'
    const activePlacement = placements.find(
      placement => placement.dataset.rebuyWidgetViewport === activeViewport,
    )

    placements.forEach(placement => {
      if (placement === activePlacement) {
        return
      }

      const widgetElement = getWidgetElement(placement)

      if (widgetElement) {
        widgetCache.set(widgetElement.dataset.rebuyId, widgetElement)
        widgetElement.remove()
      }
    })

    if (!activePlacement) {
      return
    }

    if (getWidgetElement(activePlacement)) {
      initializeRebuy()
      return
    }

    const template = activePlacement.querySelector('[data-rebuy-widget-template]')
    const widgetId = template?.content.firstElementChild?.dataset.rebuyId
    const widgetElement = widgetCache.get(widgetId) || template?.content.firstElementChild?.cloneNode(true)

    if (!widgetElement) {
      return
    }

    widgetCache.delete(widgetId)
    activePlacement.appendChild(widgetElement)
    initializeRebuy()
  }

  const queueWidgetUpdate = () => {
    if (updateQueued) {
      return
    }

    updateQueued = true
    window.requestAnimationFrame(updateActiveWidget)
  }

  const formatPrice = moneyElement => {
    if (moneyElement.querySelector('.price-decimals')) {
      return
    }

    const priceTextRoot =
      moneyElement.querySelector('.trans-money') ||
      [...moneyElement.children].find(element => !element.classList.contains('sr-only')) ||
      moneyElement
    const priceParts = priceTextRoot.textContent
      .trim()
      .match(/^([\s\S]*)([,.])(\d{2})(?!\d)([\s\S]*)$/)

    if (!priceParts) {
      return
    }

    const separator = document.createElement('span')
    separator.className = 'price-separator'
    separator.textContent = priceParts[2]

    const decimals = document.createElement('span')
    decimals.className = 'price-decimals'
    decimals.textContent = priceParts[3]

    priceTextRoot.replaceChildren(
      document.createTextNode(priceParts[1]),
      separator,
      decimals,
      document.createTextNode(priceParts[4]),
    )
  }

  const formatWidgetPrices = () => {
    priceFormattingQueued = false
    document
      .querySelectorAll(`${PRODUCT_WIDGET_SELECTOR} ${REBUY_PRICE_SELECTOR}`)
      .forEach(formatPrice)
  }

  const queuePriceFormatting = () => {
    if (priceFormattingQueued) {
      return
    }

    priceFormattingQueued = true
    window.requestAnimationFrame(formatWidgetPrices)
  }

  const isInsidePriceWidget = node => {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement

    return Boolean(
      element?.matches?.(PRODUCT_WIDGET_SELECTOR) ||
        element?.closest?.(PRODUCT_WIDGET_SELECTOR) ||
        element?.querySelector?.(PRODUCT_WIDGET_SELECTOR),
    )
  }

  const priceObserver = new MutationObserver(mutations => {
    const priceWidgetChanged = mutations.some(
      mutation =>
        isInsidePriceWidget(mutation.target) ||
        [...mutation.addedNodes].some(isInsidePriceWidget),
    )

    if (priceWidgetChanged) {
      queuePriceFormatting()
    }
  })

  const refreshCartDrawerAfterRebuyAdd = event => {
    const addedFromWidgetId = String(event.detail?.widget?.id || '')
    const activeRebuyWidgets = document.querySelectorAll(`${ELEMENT_NAME} > [data-rebuy-id]`)
    const wasAddedFromCartDrawer = [...activeRebuyWidgets].some(
      widgetElement => widgetElement.dataset.rebuyId === addedFromWidgetId,
    )
    const productRebuyWidgets = document.querySelectorAll(PRODUCT_WIDGET_SELECTOR)
    const wasAddedFromProductWidget = [...productRebuyWidgets].some(widgetElement => {
      const widgetId = widgetElement.dataset.rebuyId || widgetElement.id.replace(/^rebuy-widget-/, '')

      return widgetId === addedFromWidgetId
    })

    if (!wasAddedFromCartDrawer && !wasAddedFromProductWidget) {
      return
    }

    const cartDrawer = document.querySelector(CART_DRAWER_SELECTOR)
    cartDrawer?.update?.()
    cartDrawer?.open?.()
  }

  class RebuyCartDrawerWidget extends HTMLElement {
    connectedCallback() {
      queueWidgetUpdate()
    }
  }

  window.customElements.define(ELEMENT_NAME, RebuyCartDrawerWidget)
  priceObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  })
  queuePriceFormatting()
  desktopMediaQuery.addEventListener('change', queueWidgetUpdate)
  document.addEventListener('rebuy.loaded', () => {
    queueWidgetUpdate()
    queuePriceFormatting()
  })
  document.addEventListener(REBUY_ADD_EVENT, refreshCartDrawerAfterRebuyAdd)
})()
